import React from "react";
import { LeadershipCard } from "@/components/LeadershipCard/LeadershipCard";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { getImageSrc } from "@/app/utils/getImageSrc";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

export const LeadershipGrid = ({ members = [], linkedin, noGrid = true }) => {
    const validMembers = members.filter(
        (member) => member && member.image?.url

    );
members.forEach((member) => {
    if (!member?.image?.url) {
        console.log("Missing Image Member:", member);
    }
});
members.forEach((member) => {
  if (member?.image?.url === "673c90065e97b4eb9202070b") {
    console.log("Problem Member:", member);
  }
});

    return (
        <>
            <div
                className={`${
                    !noGrid ? "hidden lg:grid" : "grid"
                } grid-cols-1 md:grid-cols-3 gap-8 w-full`}
            >
                {validMembers.map((member, key) => (
                    <LeadershipCard
                        key={member.id || key}
                        name={member.title}
                        designation={member.designation}
                        excerpt={member.intro}
                        alt={member.image?.alt || member.title}
                        imageSrc={getImageSrc(member.image.url)}
                        linkedin={linkedin}
                        slug={member.slug}
                    />
                ))}
            </div>

            {!noGrid && (
                <div className="w-full beneficiary-slider block lg:hidden">
                    <Swiper
                        loop={false}
                        pagination={{ clickable: true }}
                        modules={[Pagination]}
                        spaceBetween={15}
                        slidesPerView={1.15}
                        breakpoints={{
                            640: {
                                slidesPerView: 2.1,
                            },
                            1024: {
                                slidesPerView: 3.1,
                            },
                        }}
                    >
                        {validMembers.map((member, key) => (
                            <SwiperSlide key={member.id || key}>
                                <LeadershipCard
                                    name={member.title}
                                    designation={member.designation}
                                    excerpt={member.intro}
                                    alt={member.image?.alt || member.title}
                                    imageSrc={getImageSrc(member.image.url)}
                                    linkedin={linkedin}
                                    slug={member.slug}
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            )}
        </>
    );
};